

import api               from '@/api'         
export default {

  methods: 
    {
      
        getReceiptHeading(storeId,deskId)
        {
            const sp       = {'sp'         : 'spReceiptHeading'}
            const data     = {'storeId'    : storeId,'deskId' : deskId}     
            const json     = Object.assign(data, sp)
            return new Promise( async (resolve, reject)  =>  {
            api.post(json).then(res => {
              if(res.status == 200)
              {
                               
                const data = res.data.recordsets[0]    
                resolve(data)

              }
              else if(res.status==500)
              {
               
                resolve([])
                    
              } 
              else
              {
                
                resolve([])
              } 
              }).catch(err => 
              {
                
                resolve([])
                
                
              }).finally(() => {
                
              });
            })
    
        },  
      
          
    }
    
}

